export enum PostItemTypes {
	COLLECTION = 'COLLECTION',
	STORY = 'STORY',
	NEWS = 'NEWS',
}
